import { InhouseTicketSystemType } from '@api';
import { FormActions } from '@common';
import { zodResolver } from '@hookform/resolvers/zod';
import { TextareaField, TextField } from '@hypeit-gmbh/hypeit-ui';
import { Stack } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  useUpdateVenueInhouseTicketSystem,
  useVenueInhouseTicketSystemFormSchema,
  VenueInhouseTicketSystemFormDataType,
} from './hooks';

const TRANS_PATH = 'VENUE_INHOUSE_TICKET_SYSTEM.FORM';

type VenueInhouseTicketSystemFormPropsType = {
  venueId: string;
  overviewVersion: string;
  venueInhouseTicketSystem: InhouseTicketSystemType;
  onClose: () => void;
};

export const VenueInhouseTicketSystemForm: React.FC<VenueInhouseTicketSystemFormPropsType> = ({
  venueId,
  overviewVersion,
  venueInhouseTicketSystem,
  onClose,
}) => {
  const { t } = useTranslation('venueDetailsOverview');

  const { schema, defaultValues } =
    useVenueInhouseTicketSystemFormSchema(venueInhouseTicketSystem);
  const { updateVenueInhouseTicketSystem } = useUpdateVenueInhouseTicketSystem({
    venueId,
    overviewVersion,
    onClose,
  });

  const methods = useForm<VenueInhouseTicketSystemFormDataType>({
    resolver: zodResolver(schema),
    defaultValues,
  });

  const handleSubmit = async (data: VenueInhouseTicketSystemFormDataType) => {
    await updateVenueInhouseTicketSystem(data);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        <Stack>
          <TextField<VenueInhouseTicketSystemFormDataType>
            fieldName="ticketSystem"
            label={t(`${TRANS_PATH}.TICKET_SYSTEM_LABEL`)}
          />
          <TextareaField<VenueInhouseTicketSystemFormDataType>
            fieldName="notes"
            label={t(`${TRANS_PATH}.NOTES_LABEL`)}
          />
          <FormActions
            onCancel={onClose}
            saveButtonText={t('SAVE_BUTTON', { ns: 'common' })}
            cancelButtonText={t('CANCEL_BUTTON', { ns: 'common' })}
          />
        </Stack>
      </form>
    </FormProvider>
  );
};
